import { useAuth } from '@/hooks/useAuth'
import './LoginPage.css'

function GCLogo() {
  return (
    <svg width="149" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg" className="login-gc-icon">
      <path fill="#FF5A2C" d="M75,150c-41.5,0-75-33.7-75-75.2c0-1.3,0-2.5,0.1-3.8C2.1,31.8,34.7,0.5,74,0c22.7-0.4,44.3,9.6,58.7,27.1c0.9,1.1,0.8,2.8-0.3,3.7c0,0-0.1,0.1-0.1,0.1l-8,6.1c-1.1,0.9-2.7,0.7-3.6-0.4C109.3,22.9,92.2,15,74.3,15.3c-32.9,0.4-59.5,27.8-59,60.7c0.6,33,27.8,59.2,60.7,58.7c17.2-0.3,33.4-8,44.5-21.1c0.9-1.1,2.5-1.2,3.6-0.4l7.9,6.2c1.1,0.9,1.4,2.5,0.5,3.7c0,0-0.1,0.1-0.1,0.1C118.3,140.2,97.2,150.1,75,150z"/>
      <path fill="#FF5A2C" d="M75.1,119.3c-24.5,0-44.3-19.8-44.3-44.3c0-24.5,19.8-44.3,44.3-44.3c12.8,0,25,5.6,33.4,15.2c0.9,1.1,0.8,2.8-0.3,3.7c0,0-0.1,0.1-0.1,0.1l-7.9,6.2c-1.1,0.9-2.7,0.7-3.6-0.3c-10.7-11.9-29.1-12.8-40.9-2s-12.8,29.1-2,40.9c10.7,11.9,29.1,12.8,40.9,2c3.2-2.9,5.6-6.4,7.3-10.3H83.6c-1.4,0-2.6-1.2-2.6-2.6v-10c0-1.4,1.2-2.6,2.6-2.6h33.3c1.4,0,2.6,1.2,2.6,2.6c0,0,0,0.1,0,0.1c-0.1,3.1-0.4,5.6-0.4,5.6C117.1,102,98,119.4,75.1,119.3z"/>
    </svg>
  )
}

export function LoginPage() {
  const { handleSignIn, error, loading } = useAuth()

  return (
    <div className="login-page">
      <div className="login-card">
        <GCLogo />
        <h1>GC Slides</h1>
        <p className="login-subtitle">Sign in to view and comment on presentations</p>

        {error && <div className="login-error">{error}</div>}

        <button
          type="button"
          onClick={handleSignIn}
          disabled={loading}
          className="login-button"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
            <path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z"/>
            <path fill="#fff" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          {loading ? 'Signing in...' : 'Sign in with Google'}
        </button>

        <p className="login-hint">Only @globalcomix.com accounts</p>
      </div>
    </div>
  )
}
